/* eslint-disable no-shadow */
export enum ConversationSenderEnum {
	whatsapp = 'whatsapp',
}

export enum ConversationResponderEnum {
	sofia = 'sofia',
	seller = 'seller',
}

export const ConversationResponderValues = {
	[ConversationResponderEnum.sofia]: 'Sofía',
	[ConversationResponderEnum.seller]: 'Vendedor asignado',
};

export interface ResponderHistoric {
	responder: ConversationResponderEnum;
	updatedAt: string;
	by: { _id: string; name: string } | null;
}

export interface Conversation {
	_id: string;
	financialForm?: string;
	lead?: string;
	dialCode: string;
	phone: string;
	conversationId: string;
	sender: ConversationSenderEnum;
	isActive: boolean;
	infobipAgentId?: string;
	responder: ConversationResponderEnum;
	responderHistoric: ResponderHistoric[];
	createdAt: string;
	updatedAt: string;
}

export interface ConversationTableRow extends Conversation {
	sellerId?: string;
	ozonerId?: string;
}

export interface ListConversationsTableFilters {
	isActive?: boolean;
	phone?: string;
	conversationId?: string;
	sellerId?: string;
	sellerInfobipId?: string;
	responder?: ConversationResponderEnum;
	page?: number;
	limit?: number;
}

export interface ConversationsTableResponse {
	data: ConversationTableRow[];
	page: number;
	pages: number;
	count: number;
}
